module.exports = __webpack_public_path__ + "img/LocalService.1c19475f.png";